import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import 'chartjs-plugin-zoom';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { enableSentry } from './sentry';

if (environment.production) {
  enableSentry();
  enableProdMode();
}

platformBrowser()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch((err) => console.log(err));
